import { render, staticRenderFns } from "./LabelhomePhone.vue?vue&type=template&id=66341c0b&"
import script from "./LabelhomePhone.vue?vue&type=script&lang=js&"
export * from "./LabelhomePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports